export const getStaticPageLayout = state => state.staticPageLayout;

export const getShouldHideStaticPageMenuAndSearch = (
  state,
  isGenericStaticPageRoute = false
) => {
  const layout = state.staticPageLayout;

  // Catch-all static page route is known before the lazy page mounts.
  // Hide chrome until a successful response resolves layout flags.
  if (isGenericStaticPageRoute) {
    if (!layout?.isStaticPageRoute || !layout.layoutResolved) {
      return true;
    }

    return !!layout.hideMenuAndSearch;
  }

  if (!layout?.isStaticPageRoute) {
    return false;
  }

  return !layout.layoutResolved || !!layout.hideMenuAndSearch;
};
